/*
 * @Author: yanni
 * @Date: 2022-02-23 14:37:07
 * @Description: 
 */
import service from './service';
import configAos from '../../config/config.aos'
// import configAos from './aosurl';
import configAct from '../../config/config.act';

const act_id = configAct.actId // act_id

const serviceObj = {
  // 首页数据获取接口
  index( tid='', uid='', page=1) {
    return service._loader('get', configAos.index, [
      { tid, sign: 1 },
      { act_id },
      { uid },
      { page },
      { limit: 20 },
      { type: 'oil_invite_new' },
    ]);
  },
  // 好友助力接口
  call_back( tid, adiu, mobile="", verify_code="", token=0 , uid="", invite_channel="") {
    return service._loader('get', configAos.call_back, [
      { tid, sign: 1 },
      { act_id },
      { adiu },
      { mobile },
      { uid },
      { token },
      { verify_code },
      { cli:1 },
      { invite_channel}
    ]);
  },
  // 组团领取奖励
  do_reward(tid, adiu, id) {
    return service._loader('get', configAos.do_reward, [
      { tid, sign: 1 },
      { act_id },
      { adiu },
      { id },
    ]);
  },
  // 获取验证码
  verify_code(tid,adiu,mobile) {
    return service._loader('get', configAos.verify_code, [
      { act_id },
      { mobile },
      { tid, sign: 1 },
      { adiu },
    ]);
  },
  // 邀请记录通知开关
  notice_switch(tid,adiu,switch_status) {
    return service._loader('get', configAos.notice_switch, [
      { act_id },
      { switch_status },
      { tid, sign: 1 },
      { adiu },
    ]);
  },
  // 任务列表
  taskList(tid) {
    return service._loader('get', configAos.taskList, [
      { act_id },
      { tid, sign: 1 },
      { scene: 'box'},
    ]);
  },
  // 任务上报
  taskReport(tid) {
    return service._loader('get', configAos.taskReport, [
      { act_id },
      { tid, sign: 1 },
      { type:51 , sign: 1},
      { end_time: Date.now() / 1000 >> 0, sign: 1},
      { start_time: Date.now() / 1000 >> 0}
    ]);
  },
};

Object.keys(serviceObj).forEach(k => {
  service._install(serviceObj[k], k);
});

export default service;
